<template>
    <router-link
        :to="
            this.tagItem.model === 'label' ?
            '/search?q=' + this.tagItem.name :
            '/search?selectedSubcategories=' + this.tagItem.id
        "
        class="tags pointer"
        :style="{ backgroundColor: color }"
    >
        {{ tagItem.name }}
    </router-link>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

export default {
    name: "TagItem",
    props: {
        tagItem: null,
        color: ''
    },
    computed: {
        ...mapGetters('color', [
            'getColorForModel'
        ]),
    },
    methods: {
        ...mapActions('search', [
            'updateQuery',
            'addQuerySubCategory',
            'toggleSearch'
        ]),
    }
}
</script>

<style scoped>
.tags:hover{
    color: white!important;
}
</style>
